import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
  Avatar,
  Dialog,
  IconButton,
} from "@mui/material";
import PresentToAllRoundedIcon from "@mui/icons-material/PresentToAllRounded";
import Groups2RoundedIcon from "@mui/icons-material/Groups2Rounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import IITGRoupIMg from "../assets/IITGROUP.png";
import panel from "../assets/panel.png";
import Sir1 from "../assets/Sir1.png";
import aaa from "../assets/AAA.png";
import Chief from "../assets/Chief.png";
import Deep from "../assets/deep.png";
import g1 from "../assets/IMG-20260327-WA0013.jpg";
import g2 from "../assets/IMG-20260327-WA0052.jpg";
import g3 from "../assets/IMG-20260328-WA0004.jpg";
import g4 from "../assets/IMG-20260328-WA0007.jpg";
import g5 from "../assets/IMG-20260329-WA0087.jpg";
import g6 from "../assets/deep.png";
import g7 from "../assets/Screenshot_2026-03-27-16-46-02-811_com.whatsapp.jpg";
import g8 from "../assets/IMG-20260328-WA0130.jpg";
import g9 from "../assets/Sir1.png";
import g10 from "../assets/aord.png";

const gallery = [
  {
    id: 1,
    title: "SETU Event",
    subtitle: "Innovation, learning, and recognition at IIT Indore",
    image: IITGRoupIMg,
  },
  {
    id: 2,
    title: "The Investor Lens on Deeptech Healthcare Innovators",
    subtitle: "Panel discussion and investor insights",
    image: panel,
  },
  {
    id: 3,
    title: "Anil Gupta Sir",
    subtitle: "Learning from grassroots innovation leadership",
    image: Chief,
  },
  {
    id: 4,
    title: "SETU Moments",
    subtitle: "Memorable moments from the event",
    image: aaa,
  },
  {
    id: 5,
    title: "Event Session",
    subtitle: "Networking and ecosystem engagement",
    image: Sir1,
  },
  {
    id: 6,
    title: "Deeptech Discussion",
    subtitle: "Innovation meets execution",
    image: Deep,
  },
];

const photoGallery = [
  { id: 1, image: g7, title: "Directors " },
  { id: 2, image: g2, title: "Dr. K. Sivan sir We were honored to have the initiative inaugurated , Chairperson, BoG, IIT Indore, and the visionary leader who steered India toward the moon. " },
  { id: 3, image: g3, title: "Describe FLUDEE Features  " },
  { id: 4, image: g4, title: "World 1st Smart IV Stand " },
  { id: 5, image: g5, title: "Mr. Kishlaya Mishra (Senior Investment Officer,  Asian Infrastructure Investment Bank (AIIB))" },
  { id: 6, image: g6, title: "Deeptech Healthcare Innovators" },
  { id: 7, image: g9, title: " Event session" },
  { id: 8, image: g10, title: "presentation at Nalanda Auditorium" },
  { id: 9, image: g1, title: "FLUDEE Booth " },
  { id: 10, image: g8, title: "FLUDEE TEAM" },
];

function useAutoSlide(length, delay = 4000) {
  const [active, setActive] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % length);
    }, delay);

    return () => clearInterval(timer);
  }, [length, delay]);

  return [active, setActive];
}

const timeline = [
  {
    no: "01",
    title: "Selected for SETU 2026",
    text: "We were selected as participants for SETU 2026 at IIT Indore under the IITI Drishti CPS Foundation.",
  },
  {
    no: "02",
    title: "Stakeholder Engagement Training",
    text: "We explored data privacy, market fit, networking, and meaningful ecosystem engagement.",
  },
  {
    no: "03",
    title: "FLUDEE Presentation",
    text: "We presented FLUDEE at Nalanda Auditorium, sharing the vision, impact, and technical capabilities of our healthcare innovation.",
  },
  {
    no: "04",
    title: "Live Demo & Investor Insights",
    text: "We demonstrated FLUDEE at Charak Center and learned from deeptech investors, healthcare experts, and innovation leaders.",
  },
];

function SectionHeader({ tag, title, subtitle, align = "left" }) {
  return (
    <Stack
      spacing={1.5}
      sx={{
        mb: { xs: 4, md: 5 },
        alignItems: align === "center" ? "center" : "flex-start",
        textAlign: align,
      }}
    >
      <Chip
        label={tag}
        sx={{
          fontWeight: 800,
          color: "#1d4ed8",
          bgcolor: "rgba(29,78,216,0.10)",
          borderRadius: "999px",
        }}
      />
      <Typography
        sx={{
          fontWeight: 900,
          color: "#0f172a",
          lineHeight: 1.05,
          fontSize: { xs: "2rem", sm: "2.7rem", md: "3.4rem" },
          letterSpacing: "-0.03em",
          maxWidth: 900,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            color: "#475569",
            lineHeight: 1.9,
            fontSize: { xs: "1rem", md: "1.08rem" },
            maxWidth: 860,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
}

function PremiumCard({ children, sx = {} }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "28px",
        border: "1px solid rgba(148,163,184,0.16)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.88) 100%)",
        boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}

export default function SetuEventPage() {
  const [activeSlide, setActiveSlide] = useAutoSlide(gallery.length, 4500);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = React.useState(null);

  const handleOpenPhoto = (index) => {
    setSelectedPhotoIndex(index);
  };

  const handleClosePhoto = () => {
    setSelectedPhotoIndex(null);
  };

  const handlePrevPhoto = () => {
    setSelectedPhotoIndex((prev) =>
      prev === 0 ? photoGallery.length - 1 : prev - 1
    );
  };

  const handleNextPhoto = () => {
    setSelectedPhotoIndex((prev) =>
      prev === photoGallery.length - 1 ? 0 : prev + 1
    );
  };

  const selectedPhoto =
    selectedPhotoIndex !== null ? photoGallery[selectedPhotoIndex] : null;

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedPhotoIndex === null) return;

      if (event.key === "ArrowLeft") {
        handlePrevPhoto();
      } else if (event.key === "ArrowRight") {
        handleNextPhoto();
      } else if (event.key === "Escape") {
        handleClosePhoto();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedPhotoIndex]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f8fbff",
        background:
          "radial-gradient(circle at top left, rgba(29,78,216,0.12), transparent 24%), radial-gradient(circle at top right, rgba(14,165,233,0.12), transparent 22%), linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: "10%" },
          pt: { xs: 8, md: 11 },
          pb: { xs: 8, md: 10 },
        }}
      >
        <Container maxWidth={false} disableGutters>
          <Stack spacing={{ xs: 4, md: 5 }}>
            <SectionHeader
              tag="SETU Event • IIT Indore"
              title="SETU Event – Stakeholders Engagement in Technology"
              align="center"
            />

            <PremiumCard sx={{ p: { xs: 1.2, md: 1.5 }, overflow: "hidden" }}>
              <Box sx={{ position: "relative" }}>
                {gallery.map((item, index) => (
                  <Box
                    key={item.id}
                    sx={{
                      display: index === activeSlide ? "block" : "none",
                      position: "relative",
                      borderRadius: "24px",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      src={item.image}
                      alt={item.title || "SETU Event"}
                      sx={{
                        width: "100%",
                        height: { xs: 260, sm: 380, md: 520, lg: 620 },
                        objectFit: "cover",
                        display: "block",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(180deg, rgba(15,23,42,0.12) 0%, rgba(15,23,42,0.22) 35%, rgba(15,23,42,0.74) 100%)",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        left: { xs: 20, md: 40 },
                        right: { xs: 20, md: 40 },
                        bottom: { xs: 20, md: 34 },
                      }}
                    >
                      <Stack spacing={1.4} sx={{ maxWidth: 760 }}>
                        {item.title ? (
                          <Typography
                            sx={{
                              color: "white",
                              fontWeight: 900,
                              lineHeight: 1.02,
                              letterSpacing: "-0.03em",
                              fontSize: {
                                xs: "1.9rem",
                                sm: "2.5rem",
                                md: "3.6rem",
                              },
                              maxWidth: 700,
                            }}
                          >
                            {item.title}
                          </Typography>
                        ) : null}

                        {item.subtitle ? (
                          <Typography
                            sx={{
                              color: "rgba(255,255,255,0.88)",
                              lineHeight: 1.85,
                              fontSize: { xs: "0.96rem", md: "1.06rem" },
                              maxWidth: 640,
                            }}
                          >
                            {item.subtitle}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Box>
                  </Box>
                ))}

                <Stack
                  direction="row"
                  spacing={1.2}
                  sx={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    bottom: { xs: 10, md: 14 },
                    zIndex: 5,
                  }}
                >
                  {gallery.map((_, index) => (
                    <Box
                      key={index}
                      onClick={() => setActiveSlide(index)}
                      sx={{
                        width: activeSlide === index ? 28 : 10,
                        height: 10,
                        borderRadius: "999px",
                        bgcolor:
                          activeSlide === index
                            ? "white"
                            : "rgba(255,255,255,0.45)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </PremiumCard>

            <Grid container spacing={2}>
              {[
                { label: "Event", value: "SETU 2026" },
                { label: "Venue", value: "IIT Indore" },
                { label: "Project", value: "FLUDEE" },
                { label: "Focus", value: "MedTech solutions Innovation" },
              ].map((item) => (
                <Grid item xs={6} md={3} key={item.label}>
                  <PremiumCard sx={{ height: "100%" }}>
                    <CardContent sx={{ p: 2.2 }}>
                      <Typography
                        sx={{
                          fontSize: "0.78rem",
                          color: "#64748b",
                          mb: 0.6,
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 800,
                          color: "#0f172a",
                          fontSize: { xs: "0.95rem", md: "1rem" },
                        }}
                      >
                        {item.value}
                      </Typography>
                    </CardContent>
                  </PremiumCard>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Container>
      </Box>

      <Box sx={{ px: { xs: 2, sm: 3, md: "10%" }, pb: { xs: 8, md: 12 } }}>
        <Container maxWidth={false} disableGutters>
          <Box sx={{ mb: { xs: 7, md: 10 } }}>
            <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
              <Grid item xs={12} lg={6}>
                <PremiumCard sx={{ p: { xs: 3, md: 4 } }}>
                  <Stack spacing={2.2}>
                    <Chip
                      icon={<EventRoundedIcon />}
                      label="SETU Story"
                      sx={{
                        width: "fit-content",
                        fontWeight: 800,
                        color: "#1d4ed8",
                        bgcolor: "rgba(29,78,216,0.10)",
                      }}
                    />

                    <Typography
                      sx={{
                        fontWeight: 900,
                        color: "#0f172a",
                        lineHeight: 1.1,
                        fontSize: { xs: "1.7rem", md: "2.4rem" },
                      }}
                    >
                      Our Journey at SETU 2026
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      Our Team recently had the incredible opportunity to be
                      selected as participants for SETU 2026, an
                      innovation-driven event organized by IIT Indore under the
                      IITI Drishti CPS Foundation.
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      As part of this program, we attended an intensive
                      Stakeholder Engagement and Technology Upgradation Training,
                      where we explored critical aspects shaping the future of
                      innovation—data privacy, identifying the right market fit,
                      networking, and meaningful ecosystem engagement.
                    </Typography>

                    <Typography
                      sx={{ fontWeight: 800, color: "#0f172a", pt: 1 }}
                    >
                      Showcasing FLUDEE
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      One of the proudest moments of our journey was presenting
                      our healthcare innovation, FLUDEE, on a prestigious
                      platform.
                    </Typography>

                    <Box
                      component="ul"
                      sx={{ pl: 2.5, m: 0, color: "#475569" }}
                    >
                      <Box component="li" sx={{ mb: 1, lineHeight: 1.95 }}>
                        We delivered a formal presentation at Nalanda
                        Auditorium, highlighting the vision, impact, and
                        technical capabilities of FLUDEE.
                      </Box>
                      <Box component="li" sx={{ lineHeight: 1.95 }}>
                        This was followed by a live demo session at the Charak
                        Center, where we demonstrated the real-world
                        functionality of our system in front of an esteemed
                        panel of experts.
                      </Box>
                    </Box>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      This experience not only validated our work but also
                      opened doors for meaningful collaborations across the
                      healthcare and technology ecosystem.
                    </Typography>

                    <Typography
                      sx={{ fontWeight: 800, color: "#0f172a", pt: 1 }}
                    >
                      Learning from Giants
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      A defining moment was meeting the Chief Guest, Anil Gupta
                      (Founder of GIAN & Honeybee Network). His insights on
                      grassroots innovation and inclusive development deeply
                      resonated with our team. It reinforced our belief that the
                      most impactful technology emerges from solving real-world
                      problems at the ground level.
                    </Typography>

                    <Typography
                      sx={{ fontWeight: 800, color: "#0f172a", pt: 1 }}
                    >
                      Insights from Industry & Healthcare Leaders
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      A high-impact panel discussion, chaired by Ashok Jindal,
                      brought together distinguished experts from institutions
                      like: The discussion focused on how research is being
                      transformed into scalable, deployable healthcare
                      solutions, bridging the gap between innovation and
                      real-world application.
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      At SETU 2026, the atmosphere was charged. While Day 1 felt
                      like a celebration of “what’s possible,” the panel on “The
                      Investor Lens on Deeptech Healthcare Innovators” felt like
                      the moment things got real.
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      Sitting in that room, watching Mayuresh Raut chair the
                      discussion alongside moderators Saloni Maheshwari and
                      Varun Soni, it wasn’t just a talk—it was a masterclass in
                      survival and scale.
                    </Typography>

                    <Typography
                      sx={{ fontWeight: 800, color: "#0f172a", pt: 1 }}
                    >
                      The Voices in the Room
                    </Typography>

                    <Typography sx={{ color: "#475569", lineHeight: 1.95 }}>
                      The stage was a powerhouse of venture capital and
                      incubation experts. We listened closely as the likes of
                      Amrit Tiwari, Kshitij Singh, Neha Malhotra, Sunil K.
                      Shekhawat, and Aashish Matta broke down the “Deeptech
                      Code.”
                    </Typography>

                    <Typography
                      sx={{ fontWeight: 800, color: "#0f172a", pt: 1 }}
                    >
                      Our 3 Key Takeaways from the Discussion
                    </Typography>

                    <Box
                      component="ul"
                      sx={{ pl: 2.5, m: 0, color: "#475569" }}
                    >
                      <Box component="li" sx={{ mb: 1, lineHeight: 1.95 }}>
                        <strong>Proof is the Only Currency:</strong> The panel
                        didn’t mince words. Clinical validation and regulatory
                        readiness aren’t just “check-boxes”—they are the
                        foundation of trust. Without them, even the most
                        brilliant tech is just an expensive hobby.
                      </Box>
                      <Box component="li" sx={{ mb: 1, lineHeight: 1.95 }}>
                        <strong>The “So What?” Factor:</strong> A recurring
                        theme was the gap between technical brilliance and
                        market need. The investors challenged us to think: Is
                        this solution technically robust, or is it commercially
                        viable? In the best cases, it must be both.
                      </Box>
                      <Box component="li" sx={{ lineHeight: 1.95 }}>
                        <strong>The Founder’s Grit:</strong> Beyond the unit
                        economics and the pitch decks, the investors were
                        looking for teams that understood the “execution” side
                        of the bridge. Innovation is the spark, but execution is
                        the fuel.
                      </Box>
                    </Box>
                  </Stack>
                </PremiumCard>
              </Grid>

              <Grid item xs={12} lg={6}></Grid>
            </Grid>
          </Box>

          <Box sx={{ mb: { xs: 7, md: 10 } }}>
            <SectionHeader
              tag="Event Gallery"
              title="10+ moments from SETU"
              align="center"
            />

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  sm: "repeat(3, 1fr)",
                  md: "repeat(4, 1fr)",
                  lg: "repeat(5, 1fr)",
                },
                gap: { xs: 1.2, sm: 1.8, md: 2.2 },
              }}
            >
              {photoGallery.map((photo, index) => (
                <Card
                  key={photo.id}
                  elevation={0}
                  onClick={() => handleOpenPhoto(index)}
                  sx={{
                    cursor: "pointer",
                    overflow: "hidden",
                    borderRadius: "20px",
                    border: "1px solid rgba(148,163,184,0.14)",
                    background: "#fff",
                    boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 18px 40px rgba(15,23,42,0.12)",
                    },
                  }}
                >
                  <Box sx={{ position: "relative", overflow: "hidden" }}>
                    <Box
                      component="img"
                      src={photo.image}
                      alt={photo.title}
                      sx={{
                        width: "100%",
                        height: { xs: 140, sm: 180, md: 210, lg: 220 },
                        objectFit: "cover",
                        display: "block",
                        transition: "transform 0.4s ease",
                        "&:hover": {
                          transform: "scale(1.06)",
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ p: 1.4 }}>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.82rem", sm: "0.9rem" },
                        fontWeight: 700,
                        color: "#0f172a",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {photo.title}
                    </Typography>
                  </Box>
                </Card>
              ))}
            </Box>
          </Box>

          <Box sx={{ mb: { xs: 7, md: 10 } }}>
            {/* <SectionHeader tag="Journey Timeline" align="center" /> */}

            {/* <Grid container spacing={2.5}>
              {timeline.map((item) => (
                <Grid item xs={12} md={6} key={item.no}>
                  <PremiumCard sx={{ height: "100%" }}>
                    <CardContent sx={{ p: { xs: 2.5, md: 3.2 } }}>
                      <Stack direction="row" spacing={2} alignItems="flex-start">
                        <Avatar
                          sx={{
                            width: 56,
                            height: 56,
                            bgcolor: "#1d4ed8",
                            color: "#fff",
                            fontWeight: 900,
                            flexShrink: 0,
                          }}
                        >
                          {item.no}
                        </Avatar>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 800,
                              color: "#0f172a",
                              fontSize: "1.06rem",
                              mb: 1,
                            }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            sx={{ color: "#475569", lineHeight: 1.85 }}
                          >
                            {item.text}
                          </Typography>
                        </Box>
                      </Stack>
                    </CardContent>
                  </PremiumCard>
                </Grid>
              ))}
            </Grid> */}
          </Box>

          <PremiumCard
            sx={{
              overflow: "hidden",
              background: "linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)",
              border: "none",
              boxShadow: "0 22px 70px rgba(29,78,216,0.28)",
            }}
          >
            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={8}>
                  <Stack spacing={1.5}>
                    <Chip
                      icon={
                        <Groups2RoundedIcon sx={{ color: "white !important" }} />
                      }
                      label="Innovation Recognition"
                      sx={{
                        width: "fit-content",
                        bgcolor: "rgba(255,255,255,0.14)",
                        color: "white",
                        fontWeight: 800,
                      }}
                    />
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 900,
                        lineHeight: 1.08,
                        fontSize: { xs: "1.9rem", md: "3rem" },
                      }}
                    >
                      SETU 2026 gave FLUDEE visibility, confidence, and momentum.
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.86)",
                        lineHeight: 1.9,
                        maxWidth: 850,
                      }}
                    >
                      This event was not only about participation. It was about
                      proving our direction, sharing our story, and taking
                      another strong step toward impactful healthcare
                      innovation.
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Stack
                    spacing={1.5}
                    alignItems={{ xs: "stretch", lg: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<PresentToAllRoundedIcon />}
                      sx={{
                        height: 54,
                        px: 3.5,
                        borderRadius: "16px",
                        color: "white",
                        borderColor: "rgba(255,255,255,0.45)",
                        textTransform: "none",
                        fontWeight: 800,
                        "&:hover": {
                          borderColor: "white",
                          bgcolor: "rgba(255,255,255,0.08)",
                        },
                      }}
                    >
                      View Presentation
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </PremiumCard>
        </Container>
      </Box>

      <Dialog
        open={selectedPhotoIndex !== null}
        onClose={handleClosePhoto}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            bgcolor: "#000",
            borderRadius: "20px",
            overflow: "hidden",
            minHeight: { xs: "60vh", md: "80vh" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={handleClosePhoto}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 20,
              color: "white",
              bgcolor: "rgba(255,255,255,0.16)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.28)",
              },
            }}
          >
            <CloseRoundedIcon />
          </IconButton>

          <IconButton
            onClick={handlePrevPhoto}
            sx={{
              position: "absolute",
              left: { xs: 8, md: 16 },
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 20,
              color: "white",
              bgcolor: "rgba(255,255,255,0.16)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.28)",
              },
            }}
          >
            <ArrowBackIosNewRoundedIcon />
          </IconButton>

          <IconButton
            onClick={handleNextPhoto}
            sx={{
              position: "absolute",
              right: { xs: 8, md: 16 },
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 20,
              color: "white",
              bgcolor: "rgba(255,255,255,0.16)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.28)",
              },
            }}
          >
            <ArrowForwardIosRoundedIcon />
          </IconButton>

          {selectedPhoto && (
            <Box
              component="img"
              src={selectedPhoto.image}
              alt={selectedPhoto.title}
              sx={{
                width: "100%",
                maxHeight: "82vh",
                objectFit: "contain",
                display: "block",
                bgcolor: "#000",
              }}
            />
          )}

          {selectedPhoto?.title ? (
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                p: 2,
                bgcolor: "rgba(17,24,39,0.92)",
              }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontWeight: 700,
                  fontSize: { xs: "0.95rem", md: "1.05rem" },
                  textAlign: "center",
                }}
              >
                {selectedPhoto.title} ({selectedPhotoIndex + 1} /{" "}
                {photoGallery.length})
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Dialog>
    </Box>
  );
}